<div class="row">
  <mat-form-field appearance="outline" class="field white-field" subscriptSizing="dynamic">
    <mat-label>Fecha mínima de entrega</mat-label>
    <input matInput [matDatepicker]="estimated_completion_date" [formControl]="estimatedCompletionDateControl">
    <mat-datepicker-toggle matSuffix [for]="estimated_completion_date"></mat-datepicker-toggle>
    <mat-datepicker #estimated_completion_date [startAt]=""></mat-datepicker>
    @if (showDatesWarning) {
      <mat-hint class="error">*Debe ser menor a la fecha requerida</mat-hint>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="field white-field" subscriptSizing="dynamic">
    <mat-label>Fecha de expiración de la cotización</mat-label>
    <mat-select [value]="defaultOption" (selectionChange)="onDaysChange($event.value)" [disabled]="completed">
      <mat-option *ngFor="let option of expirationOptions" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>
    @if (showDatesWarning) {
      <mat-hint ></mat-hint>
    }
  </mat-form-field>

  
</div>

<div class="row-comment">
  <mat-form-field class="field white-field" subscriptSizing="dynamic" appearance="outline">
    <mat-label>{{adminService.getText('comment','capitalize')}}</mat-label>
    <textarea
      matInput
      [formControl]="commentControl"
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="6"
      (keydown)="handleInput($event)"
    ></textarea>
  </mat-form-field>
</div>

<ng-container *ngFor="let category of categories; let last = last">

  <div *ngIf="getCategoryFormArray(category.id)?.controls?.length > 0" class="category-mobile hide-desktop" [formGroup]="form">
    <div class="mobile-product" [formArrayName]="category.id.toString()" *ngFor="let product of getCategoryFormArray(category.id)?.controls; let i = index" >
      <ng-container [formGroupName]="i">
        <!-- Visualización de datos -->
        <div class="data-row">
          <div class="checkbox">
            <mat-checkbox formControlName="checked"></mat-checkbox>  
          </div>
        </div>
        <div class="data-row" >
          <div class="product-info">
            <div class="product-name">
              <span class="value">{{ product.get('product.code').value }}</span>
            </div>
            <div class="description">
              <span class="value">{{ product.get('product.name').value }} ({{product.get('product.brand_name').value}})</span>
            </div>
          </div>
  
          <div class="required">
            <span class="label">Requerido:</span>
            <span class="value">{{ getRequiredProduct(product.get('product_id')?.value)?.quantity }}</span>
          </div>
  
          <div class="total-mobile">
            <span class="label">Total:</span>
            <span class="value">{{ product.get('quantity')?.value * product.get('amount')?.value | number:'1.2-2' }}</span>
          </div>
        </div>
  
        <!-- Campos modificables -->
        <div class="form-column">
          <div class="quantity-field">
            <mat-form-field appearance="outline" class="no-subscript mobile-field">
              <mat-label>Cantidad a ofrecer</mat-label>
              <input matInput type="number" min="0" formControlName="quantity">
            </mat-form-field>
          </div>
  
          <div class="amount-field">
            <mat-form-field appearance="outline" class="no-subscript mobile-field">
              <mat-label>Precio Unitario</mat-label>
              <input matInput currencyMask formControlName="amount" autocomplete="off">
            </mat-form-field>
          </div>
  
          <div class="checkbox-fields" formGroupName="extra_params">
            <div class="checkbox-flexible">
              <mat-checkbox formControlName="flexible">Flexible</mat-checkbox>
              <i class="fa fa-question-circle" matTooltip="Está dispuesto a vender menor cantidad al mismo precio"></i>
            </div>
            <div class="checkbox-alternative">
              <mat-checkbox formControlName="alternative">Alternativo</mat-checkbox>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="getCategoryFormArray(category.id)?.controls?.length > 0" class="category hide-mobile" [formGroup]="form" [ngClass]="{'last': last}">
    <table class="table" [formArrayName]="category.id.toString()">
      <thead>
        <tr>
          <th *ngFor="let column of humanColumnsNames">
            <ng-container [ngSwitch]="column" >
              <ng-container *ngSwitchCase="'Flexible'">
                <div class="checkbox">
                  Flexible <i class="fa fa-question-circle" matTooltip="Está dispuesto a vender menor cantidad al mismo precio"></i>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Alternativo'">
                <div class="checkbox">
                  {{ column }} 
                </div>
              </ng-container>
             
              <ng-container *ngSwitchDefault>
                {{ column }} 
              </ng-container>
            </ng-container> 
          </th>
        </tr>
      </thead>
      
      <tbody>
        <tr class="separator-row">
          <td colspan="100"></td>
        </tr>
        <tr *ngFor="let product of getCategoryFormArray(category.id)?.controls; let i = index" [formGroupName]="i">
          <td>
            <div class="checkbox">
              <mat-checkbox formControlName="checked"></mat-checkbox>  
            </div>
          </td>
          <td>
            <div class="product">
              <div class="code">
                {{ product.get('product.code').value }}
              </div>
              <div class="description">
                {{ product.get('product.name').value }}
              </div>
              <div class="brand">
                ({{product.get('product.brand_name').value}})
              </div>
            </div>
          </td>
          <ng-container formGroupName="extra_params">

            <td>
              <div class="checkbox">
                <mat-checkbox formControlName="alternative"></mat-checkbox>  
              </div>
             
            </td>
          </ng-container>
          <td>
              {{ getRequiredProduct(product.get('product_id')?.value)?.quantity }}
          </td>
          <td>
            <mat-form-field appearance="outline" class="quantity no-subscript">
              <input matInput type="number" min="0" formControlName="quantity">
            </mat-form-field>
          </td>

          <ng-container formGroupName="extra_params">
            <td>
              <div class="checkbox">
                <mat-checkbox formControlName="flexible"></mat-checkbox>
              </div>
              
            </td>
          </ng-container>
          <td>
            <mat-form-field appearance="outline" class="amount no-subscript">
              <input matInput currencyMask formControlName="amount" autocomplete="off">
            </mat-form-field>
          </td>
          <td>
            {{ product.get('quantity')?.value * product.get('amount')?.value | money }}
          </td>
          
        </tr>
      </tbody>
    </table>
  </div>


</ng-container>




<div class="totals">
  <div class="total">
    <span>Total:</span>
    <span>{{ Total | money }}</span>
  </div>
  <div class="tax">
    <span>IVA:</span>
    <span>{{ (Total * (country.preferences.tax_rate)) - Total | money }}</span>
  </div>
  <div class="final-total">
    <span>Total final:</span>
    <span>{{ (Total * (country.preferences.tax_rate)) | money }}</span>
  </div>
</div>




